import * as React from "react";
import * as _ from "lodash";
import classNames from "classnames";
import { ProxyBaseClass } from "@bizform/core/dist/js/bizflow/core.min";

type Props = {
    menuItem: any;
};

type State = {
};

@ProxyBaseClass("low", "componentWillUnmount")
export class HiddenButtonItem extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this._onClick = this._onClick.bind(this);
    }

    componentWillUnmount(): void {
    }

    private _onClick(e: React.MouseEvent): void {
        if (this.props.menuItem.command) {
            /*
            this.props.menuItem.command({
                originalEvent: e,
                item: this.props.menuItem
            });
            */
            this.props.menuItem.command(e);
            e.preventDefault();
        }
    }

    render(): React.ReactNode {
        const className = classNames("p-menuitem-link", { "p-disabled": this.props.menuItem.disabled });
        // const icon = this.props.menuItem.icon ? <span className={classNames("p-menuitem-icon", this.props.menuItem.icon)}></span> : null;
        const icon = _.trim(this.props.menuItem.iconClass) ? <i className={_.trim(this.props.menuItem.iconClass)}></i> : null;
        const label = <span className="p-menuitem-text">{this.props.menuItem.label}</span>;

        return (
            <li className="p-menuitem" role="menuitem">
                <a href={this.props.menuItem.url || "#"} className={className} target={this.props.menuItem.target} onClick={this._onClick}>
                    {icon}
                    {label}
                </a>
            </li>
        );
    }
}